<template lang="pug">
  div.page-content-wrapper
    .loadingData(v-if="isLoadingData")
</template>

<script>
import PATHS from '../../../../router/routesMap.js'
import axios from '../../../../../build/http-requests/axios-common.js'

export default {
  name: 'OfdaDeepLink',

  data () {
    return {
      isLoadingData: false
    }
  },

  methods: {
    registerLink () {
      let link = this.$route.query.link
      let institution = this.$route.query.institution
      let accData = this.$route.query.bankAccountId.split('|')

      this.isLoadingData = true

      let account = {
        bank: {},
        name: null,
        accountNumber: null,
        agency: null
      }
      account.bank.codigo = accData && accData.length > 0 ? accData[0] : null
      account.agency = accData && accData.length > 1 ? accData[1] : null
      account.accountNumber = accData && accData.length > 2 ? accData[2] : null
      account.linkOFDA = link
      account.institutionOFDA = institution

      axios.post('/bankAccounts/linkAccoutToOFDA', account).then((responseSaveAcc) => {
        this.isLoadingData = false
        this.$store.dispatch('setHasUnsavedChanges', false)
        this.$store.dispatch('cleanBankAccountToEdit')
        location.href = PATHS.LIST_BANK_ACCOUNTS
      }).catch(() => {
        this.isLoadingData = false
        this.$store.dispatch('setHasUnsavedChanges', false)
        this.$store.dispatch('cleanBankAccountToEdit')
        location.href = PATHS.LIST_BANK_ACCOUNTS
        this.$root.$refs.notification.error('Erro ao associar conta bancária à autorização OFDA.')
      })
    },

    redirectAccountList () {
      this.$store.dispatch('setHasUnsavedChanges', false)
      this.$store.dispatch('cleanBankAccountToEdit')
      location.href = PATHS.LIST_BANK_ACCOUNTS
    }
  },

  created () {
    this.registerLink()
  }
}
</script>



// WEBPACK FOOTER //
// OfdaDeepLink.vue?177e24ed